<it-card teaser="true" shadow="true" *ngIf="attachTypes?.length">
  <div class="row mt-2">
    <div class="col">
      <div class="mb-3">
        <it-select
          label="Tipologia Nota"
          [(ngModel)]="selectedTypeAttachId"
        >
          <option [value]="null">Seleziona la tipologia di allegato</option>
          <option *ngFor="let type of attachTypes" [value]="type.id">
            {{ type.name }}
          </option>
        </it-select>
      </div>
      <div class="mb-3" *ngIf="selectedTypeAttachId && selectedTypeAttachId >= 0">
        <it-upload-drag-drop (fileStartUpload)="onDragUploadStart($event)" #uploadDragDropComponent></it-upload-drag-drop>
      </div>
    
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
      </div>
    </div>
  </div>    
  </it-card>
  